import { convertReducersToSectionReducers } from "./convertReducersToSectionReducers";
import { EventEmitter } from "../tools/EventEmitter";
export const createSection = ({ dynadux, createSectionConfig, }) => {
    const { section, initialState, reducers, onChange, } = createSectionConfig;
    const sectionActions = Object.keys(reducers);
    const sectionChangeEventEmitter = new EventEmitter();
    const dynaduxOnChange = dynadux._onChange;
    dynadux._onChange = (state, action, payload) => {
        if (sectionActions.includes(action)) {
            sectionChangeEventEmitter.trigger(state, action, payload);
            onChange === null || onChange === void 0 ? void 0 : onChange(state[section], action, payload);
        }
        dynaduxOnChange(state, action, payload);
    };
    if (dynadux.state[section])
        throw new Error(`dynadux: createSection: Section or root property "${section}" already exists, section couldn't be created.`);
    dynadux.setSectionInitialState(section, initialState);
    dynadux.addReducers(convertReducersToSectionReducers(section, reducers));
    return {
        get storeState() {
            return dynadux.state;
        },
        get state() {
            return dynadux.state[section];
        },
        dispatch: dynadux.dispatch,
        addChangeEventListener: (cb) => sectionChangeEventEmitter.addEventListener(cb),
        removeChangeEventListener: (cb) => sectionChangeEventEmitter.removeEventListener(cb),
    };
};
